import { epicRequest } from 'app'

export const TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH = 'TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH'
export const TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_ERROR = 'TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_ERROR'
export const TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_FULFILLED = 'TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_FULFILLED'
export const TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_CANCELED = 'TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_CANCELED'

export const tournamentStageTeamRelocateFetch = (stageId, teamId, group, position) => ({
  notification: {
    id: teamId,
    children: group
      ? `Moviendo equipo al grupo "${group}" en la posición "${position}"`
      : 'Moviendo equipo al grupo fuera del grupo',
  },
  payload: { group, position, stage_id: stageId, team_id: teamId },
  type: TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH,
})

export const tournamentStageTeamRelocateFetchFulfilled = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_FULFILLED,
})

export const tournamentStageTeamRelocateFetchCanceled = () => ({
  payload: null,
  type: TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_CANCELED,
})

export const tournamentStageTeamRelocateFetchError = (payload) => ({
  payload,
  type: TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_ERROR,
})

export const tournamentStageTeamRelocateFetchEpic = epicRequest({
  actionType: TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH,
  errorAction: tournamentStageTeamRelocateFetchError,
  fulfilledAction: tournamentStageTeamRelocateFetchFulfilled,
  overlap: true,
  request: ({ payload }) => ({
    body: payload,
    method: 'post',
    url: 'sports/soccer/stages/teams/relocate',
  }),
  untilTypes: TOURNAMENT_PAGE_STAGE_TEAM_RELOCATE_FETCH_CANCELED,
})
